import { lazy } from "react";
import { PATHS } from "@/lib/router";

const ActivityLogPage = lazy(() => import("./pages/ActivityLogPage"));

export const activityLogRoutes = [
  {
    path: PATHS.ACTIVITY_LOG,
    element: <ActivityLogPage />,
    handle: {
      permission: { resource: "activity_log", action: "view" },
      defaultView: true,
    },
  },
];
